import type { MessageCatalog } from './types';

export type TranslateVars = Readonly<Record<string, string | number>>;

const PLACEHOLDER = /\{(\w+)\}/g;

/**
 * Look up `key` in the active catalog, then English, then the raw key.
 * Replaces `{name}` once, so a value that itself contains `{name}` is left
 * as typed. Each value is wrapped in isolates so mixed Hebrew and Latin
 * text keeps its order.
 */
export function translate(
  catalog: MessageCatalog,
  fallback: MessageCatalog,
  key: string,
  vars?: TranslateVars,
): string {
  const template = catalog[key] ?? fallback[key] ?? key;
  if (!vars) return template;
  return template.replace(PLACEHOLDER, (match, name: string) => {
    const value = vars[name];
    return value === undefined ? match : isolate(String(value));
  });
}

/** Unicode isolate wrappers (FSI/PDI), the same marks Insights uses. */
export function isolate(value: string): string {
  return `\u2068${value}\u2069`;
}

/** Placeholder names in order, including repeats. */
export function placeholderNames(template: string): string[] {
  return [...template.matchAll(PLACEHOLDER)].map((match) => match[1]);
}
